module.exports = __webpack_public_path__ + "assets/media/5.f4d9cb16.wav";